<template>
  <div class="proofPayBox">
    <div class="proofPayBox_title">收银台</div>
    <div class="proofPayBox_infoBox">
      <div class="proofPayBox_infoTitle">
        <span>订单已提交！</span>
        <span style="font-size: 14px">打款金额：<span style="font-size: 20px; color: #ff4019" v-if="orderData.payMoney">
            ￥{{ orderData.payMoney.toFixed(2) }}</span></span>
      </div>
      <span class="proofPayBox_infoText" style="margin-top: 18px">本订单在贵单位信用额度之内，平台将立即给您发货</span><span class="proofPayBox_infoText" style="margin-top: 5px">
        请贵单位在收货后尽快用
        <span style="color: #f00">对公账户</span>
        按以下信息汇款（
        <span style="color: #f00">确保打款账户和开票账户相同</span>
        ）</span>

      <span class="proofPayBox_infoText" style="margin-top: 18px">收款账号：<span style="font-size: 18px" id="userNum">{{
          orderData.bankAccount
        }}</span><span class="copyTrackingNumber" style="
            font-size: 12px;
            color: #f89a00;
            margin-left: 10px;
            cursor: pointer;
          " data-clipboard-target="#userNum" @click="copyNum">复制20位账号</span></span><span class="proofPayBox_infoText">收款公司名：{{ orderData.bankCompany }}</span>
      <span class="proofPayBox_infoText">开户行联行号：310301000215</span>
      <span class="proofPayBox_infoText">开户行名称：{{ orderData.bankAddress }}</span><span class="proofPayBox_infoText">备注信息：<span style="color: red; font-size: 12px">为便于财务核款，付款备注信息需加上：单位名称+鲜丰汇+登录账号（可选）</span></span>
      <span class="proofPayBox_infoText" style="margin-top: 18px">本订单支付款项将于确认收货后的15个工作日内直接结算给供应商，以确保配送及服务质量</span>
    </div>
    <div class="proofPayBox_title">
      您可以通过下列一种方式提供凭证（等待上传凭证）
    </div>
    <div class="proofPayBox_uploadBox">
      <div class="proofPayBox_uploadTitle">
        <div class="iconBox"><i class="el-icon-right"></i></div>
        <span>在线上传付款凭证：</span>
      </div>
      <div class="proofPayBox_upload">
        <span class="proofPayBox_uploadText">在线上传：</span>
        <div class="proofPayBox_fileBox">
          <span style="width: 260px">{{ fileName }}</span><i @click="handleChange('')" class="el-icon-close" v-show="fileList.length > 0" style="cursor: pointer"></i>
        </div>
        <el-upload class="upload-demo" action="" :auto-upload="false" accept=".jpg,.gif,.png,.pdf" :on-change="handleChange" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :show-file-list="false">
          <div class="proofPayBox_uploadBtn">浏览...</div>
        </el-upload>
        <div class="proofPayBox_uploadTip">
          请上传jpg/gif/png/pdf格式的文件，文件不超过500k
        </div>
      </div>
      <div class="proofPayBox_uploadBtnBox">
        <el-button type="primary" class="proofPayBox_uploadBtn2" @click="uploadProof()">
          <!-- <div class="uploadIcon">
            <i class="el-icon-caret-right"></i>
            </div> -->
          上传
        </el-button>
        <el-button class="proofPayBox_uploadBtn2" style="border-color: #f89a00; margin-left: 15px" @click="
            $router.push({
              path: '/orderDetails',
              query: { id: $store.state.orderId },
            })
          ">稍后上传</el-button>
      </div>
      <div class="proofPayBox_bottomTip">
        请您于收到发票后的十个工作日内完成对公付款并上传付款凭证，<br />付款凭证可在采购人中心-我的订单-订单详情内上传。
      </div>
    </div>
    <!-- <div class="proofPayBox_foot">
      <div class="proofPayBox_footList">凭证状态</div>
      <div class="proofPayBox_footList">{{ status }}</div>
      <div class="proofPayBox_footList">您已上传的文件（点击看大图）</div>
      <div class="proofPayBox_footList">详细交易信息</div>
      <div class="proofPayBox_footList">无</div>
    </div> -->
  </div>
</template>

<script>
import { httpConfig } from "../common/config.js";
import { doGet, doPost, postAction } from "../common/HttpHelper.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      fileName: "",
      fileList: [],
      orderData: "",
      status: "等待上传凭证",
      token:localStorage.getItem('xfh_usertoken'),
    };
  },
  mounted() {
    var that = this;
    doGet(
      httpConfig.proofPay.getInfoUrl,
      {
        orderId: this.$store.state.orderId,
      },
      function (res) {
        if (res.flag) {
          that.orderData = res.data;
        } else {
          that.$message({
            type: "error",
            message: res.message,
          });
        }
      },
      function (res) {}
    );
  },
  methods: {
    //拷贝快递单号
    copyNum() {
      // 括号中的内容：对应复制按钮的class
      let clipboard = new Clipboard(".copyTrackingNumber");
      let that = this;
      clipboard.on("success", function (e) {
        that.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        that.$message({
          message: "复制失败",
          type: "error",
        });
        clipboard.destroy();
      });
    },
    handleChange(file, fileList) {
      if (file == "") {
        this.fileList = [];
        this.fileName = "";
      } else {
        this.fileList = [file];
        this.fileName = file.name;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadProof() {
      if (this.fileList.length == 0) {
        this.$message.warning("请先选择文件");
      } else {
        const params = new FormData();
        params.append("token", this.token);
        params.append("orderId", this.$store.state.orderId);
        params.append("file", this.fileList[0].raw);
        var that = this;
        postAction(
          httpConfig.proofPay.uploadProof,
          params,
          function (res) {
            if (res.flag) {
              that.$message({
                type: "success",
                message: "上传成功",
              });
              that.status = "上传成功";
              that.$router.push({
                path: "/orderDetails",
                query: { id: that.$store.state.orderId },
              });
            } else {
              that.$message({
                type: "error",
                message: res.message,
              });
            }
          },
          function (res) {}
        );
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/proofPay";
</style>



// WEBPACK FOOTER //
// src/components/page/proofPay.vue